const routes = [
  {
    path: '/log',
    name: 'log',
    component: () => import('./pages/logManage'),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
  
  {
    path: '/databaseBackup',
    name: 'databaseBackup',
    component: () => import('./pages/DatabaseBackup'),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
]
export default routes